import styled from 'styled-components';

import { Button } from '@xing-com/crate-lebenslauf-button';
import { PAGE_WIDTH, PAGE_HEIGHT } from '@xing-com/crate-lebenslauf-constants';
import { Template } from '@xing-com/crate-lebenslauf-xinglets';
import { xdlColorBorder, xdlColorDimming } from '@xing-com/tokens';

const PreviewTop = 89;
const PreviewHeaderHeight = 91;
const PreviewFooterHeight = 115;
const AnschreibenBannerHeight = 68;

// ScaleContainer, Scale and ScaleContent: we have 3 levels for scaling
// * Scale Container: position and dimension. size is flexible (e.g. height: 500px)
// * Scale: applies the scaling (e.g. scale 0.5)
// * TemplateStyled: A4 page dimensions. size is fixed (e.g. height: 1000px)
export const ScaleContainer = styled.div<{
  $openPreview: boolean;
  $showAnschreibenBanner: boolean;
}>`
  /* the first argument on the min is when the screen width is bigger than the height. the second is the opposite */
  --scaleHeight: min(
    calc(
      100vh - ${PreviewTop}px - ${PreviewHeaderHeight}px -
        ${PreviewFooterHeight}px -
        (
          ${({ $showAnschreibenBanner }) =>
            $showAnschreibenBanner ? `${AnschreibenBannerHeight}px` : '0px'}
        )
    ),
    calc(var(--previewWidth) * ${PAGE_HEIGHT} / ${PAGE_WIDTH})
  );
  height: var(--scaleHeight);
  width: calc(var(--scaleHeight) * ${PAGE_WIDTH} / ${PAGE_HEIGHT});
  margin: 0 auto;
  outline: 1px solid ${xdlColorBorder};
  overflow: hidden;
  position: relative;
  transform-origin: top center;

  ${({ $openPreview }) =>
    $openPreview &&
    `
  &::after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${xdlColorDimming};
    opacity: 0;
    transition: opacity 0.3s linear, background-color 0.3s linear;
  }

  &:hover::after {
    background-color: ${xdlColorDimming};
    opacity: 0.6;
  }

  &:hover button {
    opacity: 1;
  }
  `}
`;

export const Scale = styled.div<{ $scale: number }>`
  transform: scale(${(props) => props.$scale});
  transform-origin: top left;
  height: ${(props) => PAGE_HEIGHT * props.$scale}px;
  width: ${(props) => PAGE_WIDTH * props.$scale}px;
`;

export const TemplateStyled = styled(Template)`
  width: ${PAGE_WIDTH}px;
  height: ${PAGE_HEIGHT}px;
`;

export const StyledButton = styled(Button)`
  position: absolute;
  opacity: 0;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 1;
  transition: opacity 0.3s linear;
`;
